/* tslint:disable */
/* eslint-disable */
/**
 * SBL API Glommen Mjøsen Skog
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import { GmModelLibraryModelsEntrepreneurModel } from '../model';
/**
 * EntrepreneurApi - axios parameter creator
 * @export
 */
export const EntrepreneurApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get entrepreneurs
         * @param {number} [doNotShowCivilCultureEntrepreneurs] Optional, set &#x3D; 1 to remove Civil culture entrepreneurs (those who does not exists in VH)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        entrepreneurGetEntrepreneurs: async (doNotShowCivilCultureEntrepreneurs?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/entrepreneurs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (doNotShowCivilCultureEntrepreneurs !== undefined) {
                localVarQueryParameter['doNotShowCivilCultureEntrepreneurs'] = doNotShowCivilCultureEntrepreneurs;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EntrepreneurApi - functional programming interface
 * @export
 */
export const EntrepreneurApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EntrepreneurApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get entrepreneurs
         * @param {number} [doNotShowCivilCultureEntrepreneurs] Optional, set &#x3D; 1 to remove Civil culture entrepreneurs (those who does not exists in VH)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async entrepreneurGetEntrepreneurs(doNotShowCivilCultureEntrepreneurs?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GmModelLibraryModelsEntrepreneurModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.entrepreneurGetEntrepreneurs(doNotShowCivilCultureEntrepreneurs, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EntrepreneurApi.entrepreneurGetEntrepreneurs']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * EntrepreneurApi - factory interface
 * @export
 */
export const EntrepreneurApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EntrepreneurApiFp(configuration)
    return {
        /**
         * 
         * @summary Get entrepreneurs
         * @param {number} [doNotShowCivilCultureEntrepreneurs] Optional, set &#x3D; 1 to remove Civil culture entrepreneurs (those who does not exists in VH)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        entrepreneurGetEntrepreneurs(doNotShowCivilCultureEntrepreneurs?: number, options?: any): AxiosPromise<Array<GmModelLibraryModelsEntrepreneurModel>> {
            return localVarFp.entrepreneurGetEntrepreneurs(doNotShowCivilCultureEntrepreneurs, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EntrepreneurApi - object-oriented interface
 * @export
 * @class EntrepreneurApi
 * @extends {BaseAPI}
 */
export class EntrepreneurApi extends BaseAPI {
    /**
     * 
     * @summary Get entrepreneurs
     * @param {number} [doNotShowCivilCultureEntrepreneurs] Optional, set &#x3D; 1 to remove Civil culture entrepreneurs (those who does not exists in VH)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntrepreneurApi
     */
    public entrepreneurGetEntrepreneurs(doNotShowCivilCultureEntrepreneurs?: number, options?: RawAxiosRequestConfig) {
        return EntrepreneurApiFp(this.configuration).entrepreneurGetEntrepreneurs(doNotShowCivilCultureEntrepreneurs, options).then((request) => request(this.axios, this.basePath));
    }
}

